import { PersonCompanyRole, PersonContactType } from '@modeso/types__aumico-lib-companies-be';
import { TasksUpdate } from '../enums/tasks-update.enum';

/**
 * REV-22155 — values of the person form ("+ Neue Person" and profile). The page converts
 * `IPersonDTO` ↔ `IPersonForm`; the `person-form` pure view only works with this shape.
 */
export interface IPersonForm {
    firstName: string;
    lastName: string;
    /** User id of the Mandatsleiter. */
    assignee: string | null;
    /** "Zuständig seit" of the Mandatsleiter; the form sets today when the Mandatsleiter changes. */
    assignedOn: Date | null;
    /** User id of the Sachbearbeiter. */
    clerk: string | null;
    assignedOnClerk: Date | null;
    street: string;
    additionToAddress: string;
    zip: string;
    city: string;
    /** One value per entry. The form only emits filled rows. */
    contacts: { type: PersonContactType; value: string }[];
    /** `companyName` / `companyDeleted` are only shown — the backend sets them. */
    companies: { companyId: string; companyName: string; role: PersonCompanyRole; companyDeleted: boolean }[];
    /** Tag ids of the organization. */
    tags: string[];
    /** Choice of the Sachbearbeiter dialog; only set when the Sachbearbeiter changed. */
    tasksUpdate?: TasksUpdate;
}
